import React from 'react';
import styled from 'styled-components';
import {fontSize} from '../../mixins';
import FeaturesList from './FeaturesList';
import Card from '../../UI/Card';

const StyledTitle = styled.p`
  font-weight: 700;
  ${fontSize(20)};
  line-height: 25px;
  color: #323232;
  letter-spacing: -0.313529px;
  margin: 7px 0;
  word-break: break-all;
  text-align: left;
`



const DeskTry = () => (
    <Card>
        <StyledTitle>Try Geozilla</StyledTitle>
        <FeaturesList/>
    </Card>
);

export default DeskTry;